import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonComponentConfig, IconComponentConfig, IconType } from '@rappider/rappider-components/utils';
import { MenuFoldIconConfig, MenuUnfoldIconConfig } from '../../utils/menu-icon.config';
import { WorkflowDiagramInfoIcon } from '../../utils/workflow-diagram-info-icon.config';
import { WorkflowDiagramInfoModalConfig } from '../../utils/workflow-diagram-info-modal.config';
import { WorkflowDiagramInfoModalContents } from '../../utils/workflow-diagram-info-modal-contents.config';
import { DiagramButtonConfig } from '../../utils/diagram-button.config';

@Component({
  selector: 'rappider-diagram-toolbar',
  templateUrl: './diagram-toolbar.component.html',
  styleUrls: ['./diagram-toolbar.component.scss']
})
export class DiagramToolbarComponent {

  @Input() menuVisibility = false;
  @Input() zoomLevel? = 100;
  @Input() starterNodes: { id: string; name: string }[] = [];
  @Input() startNodeId: string | null = null;

  @Output() menuVisibilityChange = new EventEmitter<boolean>();
  @Output() createWorkflowEvent = new EventEmitter();
  @Output() createStepFunction = new EventEmitter();
  @Output() refreshWorkflowData = new EventEmitter();
  @Output() zoomLevelChanged = new EventEmitter<number>();
  @Output() zoomToFit = new EventEmitter<void>();
  @Output() starterNodeSelected = new EventEmitter<string | null>();

  infoModalVisible = false;
  DiagramButtonConfig = DiagramButtonConfig;
  MenuFoldIcon = MenuFoldIconConfig;
  MenuUnfoldIcon = MenuUnfoldIconConfig;
  WorkflowDiagramInfoIcon = WorkflowDiagramInfoIcon;
  WorkflowDiagramInfoModalConfig = WorkflowDiagramInfoModalConfig;
  WorkflowDiagramInfoModalContents = WorkflowDiagramInfoModalContents;

  floatingButtonMenuOptions = [
    { key: '%50', label: '%50' },
    { key: '%75', label: '%75' },
    { key: '%100', label: '%100' },
    { key: '%150', label: '%150' },
    { key: '%200', label: '%200' },
    { key: 'zoomToFit', label: 'Fit to Screen' },
    { key: 'zoomIn', label: 'Zoom In (0.2)' },
    { key: 'zoomOut', label: 'Zoom Out (-0.2)' }
  ];


  zoomMarks = { 25: '', 50: '', 75: '', 100: '', 150: '', 200: '', 250: '', 300: '' };

  ellipsisIcon: IconComponentConfig = {
    name: 'fa-regular fa-magnifying-glass',
    type: IconType.FontAwesome,
    size: '16px'
  };


  onChangeMenuVisibility() {
    this.menuVisibility = !this.menuVisibility;
    this.menuVisibilityChange.emit(this.menuVisibility);
  }

  infoModalVisibility() {
    this.infoModalVisible = !this.infoModalVisible;
  }

  zoomOut() {
    if (this.zoomLevel > 25) {
      this.zoomLevel -= 25;
      this.zoomLevelChanged.emit(this.zoomLevel);
    }
  }

  zoomIn() {
    if (this.zoomLevel < 300) {
      this.zoomLevel += 25;
      this.zoomLevelChanged.emit(this.zoomLevel);
    }
  }

  onButtonClick(button: ButtonComponentConfig) {
    if (button.key === 'refreshWorkflowData') {
      this.refreshWorkflowData.emit();
      return;
    } else if (button.text === DiagramButtonConfig[0].text) {
      this.createWorkflowEvent.emit();
    } else if (button.text === DiagramButtonConfig[1].text) {
      this.createStepFunction.emit();
    } else if (button.key === 'zoomToFit') {
      this.zoomToFit.emit();
    }
  }

  onMenuOptionClicked(event: any) {
    console.log('Menu option clicked:', event);
  }

  onZoomLevelChanged(event: number) {
    this.zoomLevel = event;
    this.zoomLevelChanged.emit(event);
  }

  onStarterNodeSelectionChange(nodeId: string | null): void {
    this.starterNodeSelected.emit(nodeId);
  }

}
